import React from 'react';
import MyParallaxContainer from "./../ParallaxContainerRoadmapComponent"
import './../App.css';
import ContactFormComponent from "./../ContactFormComponent";
const fishBg = "./images/digitalSalmons.png";

const Roadmap = () => {
    return (
        <div>
            <section>
                <MyParallaxContainer 
                    imageSrc={fishBg}
                    CompToRender={<ContactFormComponent />}
                    CompToRender2 = {<ContactFormComponent />}
                />
            </section>
        </div>
        
    );
};

export default Roadmap;